import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    window.location.href = `mailto:info@globstay.com?subject=Subscribe%20me&body=Please%20subscribe%20this%20email:%20${encodeURIComponent(email)}`;
  };

  return (
    <footer className="footer">

      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column brand">
              <div className="brand-row">
                <img src="/glob_stay_logo.png" alt="Globstay" className="brand-logo" />
              </div>
              <div className="footer-logo">
                <img src="/agf_logo_dark.png" alt="AGF Logo" className="agf-logo" />
              </div>
              <div className="social-icons">
                <a href="https://www.facebook.com/GlobStay" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.youtube.com/@Globstay.official" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.5 7.5a4 4 0 00-2.8-2.83C18.9 4.25 12 4.25 12 4.25s-6.9 0-8.7.42A4 4 0 00.5 7.5C.25 9.3.25 12 .25 12s0 2.7.42 4.5A4 4 0 003.5 19.33c1.8.42 8.5.42 8.5.42s6.9 0 8.7-.42a4 4 0 002.8-2.83c.42-1.8.42-4.5.42-4.5s0-2.7-.42-4.5zM9.75 8.5l6 3.5-6 3.5V8.5z"/>
                  </svg>
                </a>
                <a href="https://instagram.com/globstay.official" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.61-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                  </svg>
                </a>
                <a href="https://linkedin.com/company/globstay-pvt-ltd" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-column links">
              <h3 className="footer-heading">Quick Links</h3>
              <div className="footer-links">
                <a href="#about" className="footer-link">About Us</a>
                <a href="#amenities" className="footer-link">Amenities</a>
                <a href="#properties" className="footer-link">Property Types</a>
                <a href="#explore" className="footer-link">Explore 360°</a>
              </div>
            </div>

            <div className="footer-column legal">
              <h3 className="footer-heading">Legal</h3>
              <div className="footer-links">
                <a href="#privacy" className="footer-link">Privacy Policy</a>
                <a href="#terms" className="footer-link">Terms & Conditions</a>
                <a href="#disclaimer" className="footer-link">Disclaimer</a>
              </div>
            </div>

            <div className="footer-column contact">
              <h3 className="footer-heading">Contact</h3>
              <div className="footer-contact">
                <p className="contact-item">
                  <span className="contact-label">Office</span>
                  Assotech Business Cresterra, Tower-1, Office No-705, 7th Floor, Noida Uttar Pradesh 201304
                </p>
                <p className="contact-item">
                  <span className="contact-label">Location</span>
                  JP9C+7WM, Almora - Barechhina Rd, Sirar, Petshal, Uttarakhand 263601
                </p>
                <p className="contact-item">
                  <span className="contact-label">Email</span>
                  <a href="mailto:info@globstay.com" className="contact-email">info@globstay.com</a>
                </p>
              </div>
            </div>

            <div className="footer-column newsletter">
              <h3 className="footer-heading">Stay Updated</h3>
              <p className="newsletter-text">Get our latest updates, offers and community stories.</p>
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <input
                  type="email"
                  className="newsletter-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                  required
                />
                <button className="newsletter-button" type="submit">Subscribe</button>
              </form>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-inner">
              <p className="copyright">© 2025 Globstay. All rights reserved.</p>
              <div className="footer-bottom-links">
                <a href="#security" className="footer-bottom-link">Security</a>
                <a href="#cookies" className="footer-bottom-link">Cookies</a>
                <a href="#sitemap" className="footer-bottom-link">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;